var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOwnRegulation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 94,
    viewBox: "0 0 100 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 90H100V93.3333H0V90Z",
    fill: "#031C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 0L20 58.3333L38.3333 75L100 13.3333V0H78.3333Z",
    fill: "#3D83BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9997 13.3333L38.333 75L28.333 66.6667L94.9997 0H99.9997V13.3333Z",
    fill: "#1E5D8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58.3335L5 91.6668L38.3333 75.0002L20 58.3335Z",
    fill: "#D7AE88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9996 48.3332L88.5346 59.7982C87.5969 60.7355 86.3254 61.2621 84.9996 61.2621C83.6737 61.2621 82.4022 60.7355 81.4646 59.7982L75.2012 53.5348C74.2639 52.5972 73.7373 51.3257 73.7373 49.9998C73.7373 48.674 74.2639 47.4025 75.2012 46.4648L99.9996 21.6665",
    fill: "#3A8761"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0003 53.3335L69.6937 58.6402C70.3273 59.2526 70.8326 59.9851 71.1802 60.7949C71.5278 61.6047 71.7107 62.4756 71.7181 63.3568C71.7256 64.2381 71.5576 65.1119 71.2238 65.9275C70.89 66.7431 70.3972 67.4841 69.7741 68.1072C69.1509 68.7304 68.41 69.2232 67.5944 69.557C66.7788 69.8908 65.9049 70.0588 65.0237 70.0513C64.1425 70.0438 63.2716 69.861 62.4618 69.5134C61.6519 69.1658 60.9195 68.6605 60.307 68.0268L36.667 91.6668L69.7803 82.6352C72.112 82.0015 74.2377 80.7697 75.947 79.0618C78.5446 76.4594 80.0025 72.9321 80.0003 69.2552V58.3335L75.0003 53.3335Z",
    fill: "#B0D2EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 91.6665L19.445 84.4448L11.7233 76.7231L5 91.6665Z",
    fill: "#2C3A64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOwnRegulation);
export default __webpack_public_path__ + "static/media/imgOwnRegulation.b5447274082ca6797c311ac7dcc3098e.svg";
export { ForwardRef as ReactComponent };